import { Box, Button } from '@primer/react';
import React from 'react';
import { appConst } from '../../AppConst';
interface IBrandLogoProps {
    height?: number
}
const BrandLogo = (props: IBrandLogoProps) => {
    return (
        <Box>
            <Button variant='invisible' sx={{
                height: "auto"
            }}>
                <img
                    // src='https://ictu.edu.vn/wp-content/uploads/2023/02/cropped-logoww-300x300.png'
                    //src='../../images/logo.png'
                    src={appConst.appURLLogo}
                    alt='Logo'
                    style={{
                        height: `${props.height ?? 48}px`
                    }}
                />
            </Button>
        </Box>
    );
};

export default BrandLogo;